export default __webpack_public_path__ + "static/media/subramanya-kumar.1046628d.png";